import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import { BuscasService } from 'src/app/buscas/service/buscas/buscas.service';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { ModulosBuscaService } from 'src/app/shared/components/filtros-busca/service/modulos-service/modulos.service';

@Component({
  selector: 'app-bloco-buscas-salvas',
  standalone: true,
  imports: [CommonModule, MatIconModule, RouterModule],
  templateUrl: './bloco-buscas-salvas.component.html',
  styleUrls: ['./bloco-buscas-salvas.component.scss'],
})
export class BlocoBuscasSalvasComponent implements OnInit {
  searches: any[] = [];
  loading = true;

  constructor(
    private readonly buscasService: BuscasService,
    private readonly router: Router,
    private readonly authService: AuthService,
    private readonly modulosBuscaService: ModulosBuscaService,
  ) {}

  ngOnInit(): void {
    this.loadSearches();
  }

  private loadSearches(): void {
    const userId = this.authService.userID;
    const body = {
      responsibleID: userId ? parseInt(userId, 10) : 0,
      pagination: { page: 1, pageSize: 50, shortcuts: 7, ordenation: '' },
    };

    this.buscasService.listSavedSearches(body).subscribe({
      next: (res) => {
        const records = res?.data?.records || [];
        this.searches = records
          .slice(0, 7)
          .map((s: any) => ({
            ...s,
            updatedAt: this.formatDate(s.createdAt),
          }));
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      },
    });
  }

  private formatDate(dateStr: string): string {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return dateStr;
    return date.toLocaleDateString('pt-BR', {
      day: '2-digit', month: '2-digit',
    });
  }

  abrirBusca(search: any): void {
    const moduleID = search.moduleID;
    const searchID = search.savedSearchesID;

    if (!moduleID) {
      console.error('Módulo não encontrado!', search);
      return;
    }

    const rota = this.modulosBuscaService.getRotaById(moduleID);
    if (rota) {
      this.router.navigate(['/buscas', rota], {
        queryParams: { buscaSalvaId: searchID },
      });
    } else {
      console.error('Rota não encontrada para moduleID:', moduleID);
    }
  }
}